<script setup>
import { ref, reactive, watch, computed } from 'vue'

const props = defineProps({
  isOpen: Boolean,
  itemData: { type: Object, default: null }
})

const emit = defineEmits(['close', 'save'])

const initialForm = {
  id: null,
  name: '',
  code: '',
  fee: 0,
  weight: 0,
  status: 0,
  note: ''
}

const formData = reactive({ ...initialForm })

const isEdit = computed(() => !!props.itemData && !!props.itemData.id)

watch(() => props.isOpen, (newVal) => {
  if (newVal) {
    if (props.itemData) {
      Object.keys(initialForm).forEach(key => {
        formData[key] = props.itemData[key] !== undefined ? props.itemData[key] : initialForm[key];
      });
    } else {
      Object.keys(initialForm).forEach(key => {
        formData[key] = initialForm[key];
      });
    }
    // Remove any extra keys from formData to keep it perfectly clean
    Object.keys(formData).forEach(key => {
      if (!(key in initialForm)) {
        delete formData[key];
      }
    });
  }
}, { immediate: true });

const closeForm = () => {
  emit('close')
}

const handleSubmit = () => {
  const submitData = {};
  Object.keys(initialForm).forEach(key => {
    submitData[key] = formData[key];
  });
  emit('save', submitData);
}
</script>

<template>
  <div v-if="isOpen" class="form-sidebar-overlay" @click.self="closeForm">
    <div class="form-sidebar">
      <div class="d-flex justify-content-between align-items-center mb-4">
        <h4>{{ isEdit ? 'Edit Manifest' : 'Add Manifest' }}</h4>
        <button class="btn-close" @click="closeForm"></button>
      </div>

      <form @submit.prevent="handleSubmit">
        <div class="mb-3">
          <label class="form-label">Name</label>
          <input type="text" class="form-control" v-model="formData.name" required>
        </div>
        <div class="mb-3">
          <label class="form-label">Code</label>
          <input type="text" class="form-control" v-model="formData.code" required>
        </div>
        <div class="mb-3">
          <label class="form-label">Fee</label>
          <input type="number" step="0.01" class="form-control" v-model.number="formData.fee">
        </div>
        <div class="mb-3">
          <label class="form-label">Weight</label>
          <input type="number" step="0.01" class="form-control" v-model.number="formData.weight">
        </div>
        <div class="mb-3">
          <label class="form-label">Status</label>
          <select class="form-select" v-model.number="formData.status">
            <option :value="1">Active</option>
            <option :value="0">Inactive</option>
          </select>
        </div>
        <div class="mb-3">
          <label class="form-label">Note</label>
          <textarea class="form-control" v-model="formData.note" rows="3"></textarea>
        </div>
        
        <div class="d-flex gap-2 mt-4">
          <button type="button" class="btn btn-secondary w-100" @click="closeForm">Cancel</button>
          <button type="submit" class="btn btn-primary w-100">
            {{ isEdit ? 'Update' : 'Save' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<style scoped>
.form-sidebar-overlay {
  position: fixed;
  top: 0; left: 0; width: 100%; height: 100%;
  background: rgba(0,0,0,0.4);
  z-index: 9999 !important;
}
.form-sidebar {
  position: fixed;
  top: 0; right: 0;
  width: 400px; height: 100%;
  background: white;
  padding: 30px;
  box-shadow: -5px 0 15px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  overflow-y: auto;
}
@keyframes slideIn {
  from { transform: translateX(100%); }
  to { transform: translateX(0); }
}
</style>